import { TrackingPage } from '../../components/pages/track'

export default TrackingPage
